import { Component, DestroyRef, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, RouterOutlet, NavigationSkipped } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { MobileBottomNavComponent } from './shared/components/mobile-bottom-nav/mobile-bottom-nav.component';
import { LoaderService } from './services/loader.service';
import { AnalyticsService } from './services/analytics.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AsyncPipe, HeaderComponent, FooterComponent, MobileBottomNavComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true
})
export class AppComponent {
  title = 'shop-app';

  private loaderService = inject(LoaderService);
  private analytics = inject(AnalyticsService);
  isLoading$ = this.loaderService.isLoading$;

  constructor() {
    const router = inject(Router);
    const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

    router.events.pipe(takeUntilDestroyed(inject(DestroyRef))).subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.loaderService.show();
      }
      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError ||
        event instanceof NavigationSkipped
      ) {
        this.loaderService.hide();
      }
      if (event instanceof NavigationEnd && isBrowser) {
        // Report after the routed component has set its title.
        setTimeout(() => this.analytics.trackPageView(event.urlAfterRedirects));
      }
    });
  }
}
